import { render } from "./ViewPlatforms.vue?vue&type=template&id=7f6d705b&scoped=true"
import script from "./ViewPlatforms.vue?vue&type=script&lang=ts"
export * from "./ViewPlatforms.vue?vue&type=script&lang=ts"

import "./ViewPlatforms.vue?vue&type=style&index=0&id=7f6d705b&lang=less&scoped=true"
import "./ViewPlatforms.vue?vue&type=style&index=1&id=7f6d705b&lang=less"
script.render = render
script.__scopeId = "data-v-7f6d705b"

export default script